import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './MarketsPage.css';

export default function GameViewLayout() {
  return (
    <div className="markets-page">
      <nav className="markets-subnav" aria-label="Game View sections">
        <NavLink
          to="/game/summary"
          className={({ isActive }) =>
            `markets-subnav-link${isActive ? ' markets-subnav-link--active' : ''}`
          }
        >
          Summary
        </NavLink>
        <NavLink
          to="/game/live"
          className={({ isActive }) =>
            `markets-subnav-link${isActive ? ' markets-subnav-link--active' : ''}`
          }
        >
          Live
        </NavLink>
        <NavLink
          to="/game/active"
          className={({ isActive }) =>
            `markets-subnav-link${isActive ? ' markets-subnav-link--active' : ''}`
          }
        >
          Active
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
